import { IInitialStateProps } from 'context/registerContext';
import {
  DEFAULT_VALID,
  ValidationModel,
  allIsFalse,
  requiredIsValid,
} from 'helpers/utils/ValidationUtils';

export type LocalValidationType = {
  stateIsValid: () => ValidationModel;
  cityIsValid: () => ValidationModel;
  neighborhoodIsValid: () => ValidationModel;
  addressIsValid: () => ValidationModel;
  allIsValid: () => boolean;
};

export const LocalValidation = (data: IInitialStateProps) => {
  const validator: Partial<LocalValidationType> = {};

  validator.stateIsValid = () => {
    const value = data.local.inputs.state;
    const required = requiredIsValid(value, 'Estado é obrigatório');

    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.cityIsValid = () => {
    const value = data.local.inputs.city;
    const required = requiredIsValid(value, 'Cidade é obrigatória');

    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.neighborhoodIsValid = () => {
    const value = data.local.inputs.neighborhood;
    const required = requiredIsValid(value, 'Bairro é obrigatório');

    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.addressIsValid = () => {
    const value = data.local.inputs.address;
    const required = requiredIsValid(value, 'Endereço é obrigatório');

    if (required.error) {
      return required;
    }
    return DEFAULT_VALID;
  };

  validator.allIsValid = () => {
    return allIsFalse([
      validator?.stateIsValid!().error,
      validator?.cityIsValid!().error,
      validator?.neighborhoodIsValid!().error,
      validator?.addressIsValid!().error,
    ]);
  };

  return validator as LocalValidationType;
};
